import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { AWSError } from 'aws-sdk';

@Injectable({
  providedIn: 'root'
})
export class LogService {
  private readonly isTrace: boolean;
  private readonly isAssert: boolean;

  constructor() {
    this.isTrace = !environment.production;
    this.isAssert = !environment.production;
  }

  assert(test?: boolean, message?: string, ...optionalParams: any[]): void {
    if (this.isAssert) {
      console.assert(test, message, optionalParams);
    }
  }

  info(msg) {
    console.log('INFO: ' + msg);
  }

  trace(msg: string, obj?: any) {
    if (!this.isTrace) {
      return;
    }
    if (obj) {
      console.log('TRACE: ' + msg + ' -> ' + JSON.stringify(obj));
    } else {
      console.log('TRACE: ' + msg);
    }
  }

  warn(msg) {
    console.warn('WARN: ' + msg);
  }

  error(err: any, params?: any) {
    console.error('ERROR: ' + JSON.stringify(err));
    if (params) {
      console.error(JSON.stringify(params));
    }
  }
}
